import { Expose, Type } from 'class-transformer';
import { Model } from './model';
import { WhiteLabelCountryStatisticsModel } from './wl-country-statistics-model';

export class WhiteLabelMapStatisticsModel extends Model {
  @Expose() beneficiariesCount: number;
  @Expose()
  @Type(() => WhiteLabelCountryStatisticsModel)
  beneficiariesMap: WhiteLabelCountryStatisticsModel[];
}
